<template>
    <button
        class="btn-option-phonetic-consonant"
        :class="selectionClass">
        <span class="btn-option-phonetic-consonant__text">{{ optionText }}</span>
    </button>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            optionSlug: { type: String, default: 'lorem' },
            optionText: { type: String, default: 'Lorem' },
        },

        computed: {
            selectionClass(){
                let answerDataConsonantVariantFeature = this.$store.state.answerData.consonantFeatures.variant;
                if(answerDataConsonantVariantFeature === this.optionSlug){
                    return 'btn-option-phonetic-consonant--selected';
                }
            }
        }
    };
</script>

<style scoped src="@/css/components/btn-option-phonetic-consonant.css"></style>